import {
  Box,
  Button,
  Flex,
  Input,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useColorModeValue,
  Select,
} from '@chakra-ui/react';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import TranscriptController from './controllers/AudiosController';
import CampanhasController from "controllers/Campanhas/CampanhasController";
import OperacoesController from "controllers/Operacoes/OperacoesController";

const highlightStyle = `
  .highlighted-text {
    background-color: #c0ddff;
    color: #000000;
  }
`;
const pointerTranscript = `
  .destaque:hover:not(.highlighted-text) {
    background-color: #d0d0d05e;

  }
`;
const textTime = `
  .time {
    background-color: unset;
    background-color: #8f8f8f3b;
    font-size:0.7em;
    cursor:normal;
  }
  .time:hover {
    background-color: #8f8f8f3b;
    cursor:normal;
  }
`;

Number.prototype.HHMMSS = function () {
  return (new Date(this * 1000)).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0];
}

function TranscriptsView() {
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchId, setSearchId] = useState('');
  const textColor = useColorModeValue('gray.700', 'white');
  const { Audit_id } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [currentTime, setCurrentTime] = useState(0);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCampanha, setSelectedCampanha] = useState("");
  const [campanhas, setCampanhas] = useState([]);
  const [selectedCampanhaId, setSelectedCampanhaId] = useState("");
  const [selectedOperacao, setSelectedOperacao] = useState("");
  const [operacoes, setOperacoes] = useState([]);
  const [selectedOperacaoId, setSelectedOperacaoId] = useState("");


    useEffect(() => {
    const fetchOperacoes = async () => {
      try {
        const response = await OperacoesController.ListOperations();
        setOperacoes(response);
        console.error(response);
      } catch (error) {
        console.error("Error fetching Operacoesas:", error);
      }
    };
  
    fetchOperacoes();

    const fetchCampanhas = async () => {
      try {
        const response = await CampanhasController.ListCampaigns();
        setCampanhas(response);
      } catch (error) {
        console.error("Error fetching campanhas:", error);
      }
    };
    fetchCampanhas();
    
  }, []); // O array vazio garante que o efeito roda apenas uma vez

  const goToNextPage = async () => {
    try {
      setCurrentPage((prevPage) => Math.max(1, prevPage + 1));
      const nextPageData = await TranscriptController.listTranscripts(currentPage + 1, startDate, endDate);
      setData(nextPageData);
      setOriginalData(nextPageData);
      setFilteredData(nextPageData);
    } catch (error) {
      console.error('Error fetching next page data:', error);
    }
  };

  const goToPreviousPage = async () => {
    try {
      setCurrentPage((prevPage) => Math.max(1, prevPage - 1));
      const nextPageData = await TranscriptController.listTranscripts(currentPage - 1, startDate, endDate);
      setData(nextPageData);
      setOriginalData(nextPageData);
      setFilteredData(nextPageData);
    } catch (error) {
      console.error('Error fetching previous page data:', error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const profiles = await TranscriptController.listTranscripts();
        setData(profiles);
        setOriginalData(profiles);
        setFilteredData(profiles);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [Audit_id]);

  const handleSearch = () => {
    if (!searchId.trim()) {
      setFilteredData(originalData);
    } else {
      const filtered = originalData.filter(
        (transcript) => transcript.idtranscripts.toString() === searchId
      );
      setFilteredData(filtered);
    }
  };

  useEffect(() => {
    if (!searchId.trim()) {
      setFilteredData(originalData);
    } else {
      const filtered = originalData.filter(
        (transcript) => transcript.idtranscripts.toString() === searchId
      );
      setFilteredData(filtered);
    }
  }, [searchId, originalData]);

  const handleSendReport = async () => {
    try {
      const profiles = await TranscriptController.listTranscripts("1", startDate, endDate);
      setData(profiles);
      setOriginalData(profiles);
      setFilteredData(profiles);
      setCurrentPage(1);
    } catch (error) {
      console.error('Error while sending report:', error);
    }
  };

  return (
    <Flex direction="column" overflowY="auto" height="100%" width="100%">
      <Card overflowX={{ sm: 'scroll', xl: 'hidden' }}>
        <CardHeader p="6px 0px 22px px">
          <Flex flexDirection="column" mb={6} alignItems="flex-start">
            <style>{highlightStyle}</style>
            <style>{pointerTranscript}</style>
            <style>{textTime}</style>

            {/* Título "Filtrar" menor */}
            <Text fontSize="lg" fontWeight="bold" mb={4}>
              Filtrar
            </Text>

            {/* Alinhamento à esquerda com pequeno espaçamento entre os campos */}
            <Flex direction="row" alignItems="center" mb={6}>
              <Box mr={4}>
                <Input
                  type="text"
                  value={searchId}
                  onChange={(e) => setSearchId(e.target.value)}
                  variant="filled"
                  _placeholder={{ color: 'gray.400' }}
                  placeholder="Procurar por ID"
                  borderRadius="md"
                  py={2}
                  px={4}
                />
              </Box>

              <Flex direction="column" mr={4}>
                <label>
                  <Tooltip label="Datas vazias resultarão no Relatório Consolidado.">
                    Data Início:
                  </Tooltip>
                </label>
                <Input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  placeholder="Data de início"
                  size="sm"
                  borderRadius="md"
                />
              </Flex>

              <Flex direction="column" mr={4}>
                <label>
                  <Tooltip label="Datas vazias resultarão no Relatório Consolidado.">
                    Data Fim:
                  </Tooltip>
                </label>
                <Input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  placeholder="Data de fim"
                  size="sm"
                  borderRadius="md"
                />
              </Flex>
              <Select placeholder="Selecionar campanha" mt={4} value={selectedCampanha} onChange={e => {
                setSelectedCampanha(e.target.value);
                console.log("id campanha", e.target.options[e.target.selectedIndex].id);
                setSelectedCampanhaId(e.target.options[e.target.selectedIndex].id);
              }}>
                {campanhas.map(campanha => (
                  <option key={campanha.idcampanhas} value={campanha.campanha_nome} id={campanha.idcampanhas}>
                    {campanha.campanha_nome}
                  </option>
                ))}
              </Select>
              <Select placeholder="Selecionar Operacao" mt={4} value={selectedOperacao} onChange={e => {
                setSelectedOperacao(e.target.value);
                console.log("id Operacao", e.target.options[e.target.selectedIndex].id);
                setSelectedOperacaoId(e.target.options[e.target.selectedIndex].id);
              }}>
                {operacoes.map(operacao => (
                  <option key={operacao.company_id} value={operacao.description} id={operacao.id}>
                    {operacao.description}
                  </option>
                ))}
              </Select>
              <Button colorScheme="blue" size="lg" onClick={handleSendReport} borderRadius="lg" mt={4} ml={5}>
                Gerar
              </Button>
            </Flex>
            <Flex justifyContent="space-between" alignItems="center">
              <Button size="sm" onClick={goToPreviousPage} mr={250}>
                Página anterior
              </Button>
              <Text>Página atual: {currentPage}</Text>
              <Button size="sm" onClick={goToNextPage} ml={280}>
                Próxima página
              </Button>
            </Flex>
          </Flex>
        </CardHeader>

        {/* Espaço entre os filtros e a tabela */}
        <CardBody>
          <Table variant="simple" size="sm">
            <Thead>
              <Tr>
                <Th>ID</Th>
                <Th>Arquivo</Th>
                <Th>Data</Th>
                <Th>Ficha</Th>
                <Th>Ação</Th>
              </Tr>
            </Thead>
            <Tbody>
              {isLoading ? (
                <Tr>
                  <Td colSpan={7}>
                    <Flex justifyContent="center" alignItems="center">
                      <Spinner size="xl" />
                      <Text ml={2}>CARREGANDO...</Text>
                    </Flex>
                  </Td>
                </Tr>
              ) : (
                filteredData.map((transcript) => (
                  <TranscriptsRow
                    key={transcript.idtranscripts}
                    transcript={transcript}
                    setData={setData}
                    data={data}
                    handleSearch={handleSearch}
                    searchId={searchId}
                    currentTime={currentTime}
                    setCurrentTime={setCurrentTime}
                  />
                ))
              )}
            </Tbody>
          </Table>
        </CardBody>
      </Card>
      <Flex flex={1} justifyContent="center"></Flex>
    </Flex>



  );

}

function TranscriptsRow({
  transcript,
  handleSearch,
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);

  const updateCurrentTime = () => {
    const audioElement = document.getElementById(`audio-${transcript.idtranscripts}`);
    if (audioElement) {
      setCurrentTime(audioElement.currentTime);
    }
  };

  useEffect(() => {
    const audioElement = document.getElementById(`audio-${transcript.idtranscripts}`);

    const handlePlayPause = () => {
      setIsPlaying(!isPlaying);
    };

    if (audioElement) {
      audioElement.addEventListener('timeupdate', updateCurrentTime);
      audioElement.addEventListener('play', handlePlayPause);
      audioElement.addEventListener('pause', handlePlayPause);

      return () => {
        audioElement.removeEventListener('timeupdate', updateCurrentTime);
        audioElement.removeEventListener('play', handlePlayPause);
        audioElement.removeEventListener('pause', handlePlayPause);
      };
    }
  }, [transcript.idtranscripts, isPlaying]);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('pt-BR');
  };

  const toggleExpand = () => {
    setIsExpanded((prevState) => !prevState);
  };


  const openLink = (a) => {
    return;
  };

  const handleSearchInRow = () => {
    handleSearch();
  };

  return (
    <>
      <Tr>
        <Td style={{ verticalAlign: 'top' }}>{transcript.idtranscripts}</Td>

        <Td style={{ verticalAlign: 'top' }} maxW={250}>
          {transcript.arquivo}
        </Td>
        <Td style={{ verticalAlign: 'top' }}>
          {formatDate(transcript.date_start)}
        </Td>
        <Td style={{ verticalAlign: 'top' }}>{transcript.audit_nome}</Td>
        <Td style={{ verticalAlign: 'top' }}>



          <Link title="Acessar áudio." to={{ pathname: '/admin/AudioPage/' + transcript.idtranscripts, state: { numero: transcript.idtranscripts } }}>

            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-play">
              <polygon points="5 3 19 12 5 21 5 3"></polygon>
            </svg>
          </Link>

        </Td>
      </Tr>

    </>
  );
}

export default TranscriptsView;